import { isEqual } from 'lodash';
import { EVENT_ALARM_PERIOD_ASSIGN, EVENT_ALARM_PERIOD_ASSIGN_FAILURE, EVENT_ALARM_PERIOD_ASSIGN_SUCCESS, EVENT_ALARM_PERIOD_CREATE_EVENT, EVENT_ALARM_PERIOD_CREATE_EVENT_FAILURE, EVENT_ALARM_PERIOD_CREATE_EVENT_SUCCESS, EVENT_CREATE, EVENT_PATCH, EVENT_PATCH_FAILURE, EVENT_PATCH_SUCCESS, EVENT_POST, EVENT_POST_FAILURE, EVENT_POST_SUCCESS, EVENT_SET_CURRENT_FILTERS, EVENT_UPDATE_REFRESH_TIMESTAMP, EVENT_VERSION_CONFLICT_CANCEL, EVENT_VERSION_CONFLICT_RESOLVED, EVENT_VERSION_CONFLICT_RETRIEVE_FAILURE, EVENT_VERSION_CONFLICT_RETRIEVE_SUCCESS } from 'Redux/actionTypes';
import { eventsFiltersDefault } from 'Utils/events/constants';
// ------------------------------------
// Constants
// ------------------------------------
export const defaultFiltersInitialState = eventsFiltersDefault;
const filtersInitialState = defaultFiltersInitialState;
export const initialState = {
    timestamp: null,
    isSubmittingCurrentEvent: false,
    showConflictedEvent: false,
    currentFilters: filtersInitialState
};
// ------------------------------------
// Selectors
// ------------------------------------
/**
 * Simple function that takes Redux Store object and returns
 * subset of data that represents redux business-logic module slice
 * Beneficial because it encapsulates knowledge of
 * where to find that particular subset
 * @function
 * @param {Object} state redux Store object
 * @returns {Object} subset of data
 */
export const eventsModuleSelector = (state) => state.eventsModule;
export const isSubmittingCurrentEventSelector = (state) => eventsModuleSelector(state).isSubmittingCurrentEvent;
export const showConflictedEventSelector = (state) => eventsModuleSelector(state).showConflictedEvent;
export const conflictedEventSelector = (state) => eventsModuleSelector(state).conflictedEvent;
export const eventsTimestampSelector = (state) => eventsModuleSelector(state).timestamp;
/**
 * Selector function that returns currently selected filters in the Monitoring tool if any
 * @param {Object} state
 * @returns {Object||Null} Current Filters
 */
export const eventsCurrentFiltersSelector = (state) => eventsModuleSelector(state).currentFilters;
/* Selector function that returns check if current filters are equal to default filters
 * @param {Object} state
 * @returns {Boolean} True if current filters are equal to default filters, otherwise false
 */
export const isDefaultEventsCurrentFiltersSelector = (state) => isEqual(eventsModuleSelector(state).currentFilters, defaultFiltersInitialState);
// ------------------------------------
// Reducer
// ------------------------------------
// eslint-disable-next-line
const eventsReducer = (state = initialState, action) => {
    switch (action.type) {
        case EVENT_POST:
            return {
                ...state,
                isSubmittingCurrentEvent: true
            };
        case EVENT_POST_SUCCESS:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_POST_FAILURE:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_PATCH:
            return {
                ...state,
                isSubmittingCurrentEvent: true
            };
        case EVENT_PATCH_SUCCESS:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_PATCH_FAILURE:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_ALARM_PERIOD_ASSIGN:
            return {
                ...state,
                isSubmittingCurrentEvent: true
            };
        case EVENT_ALARM_PERIOD_ASSIGN_SUCCESS:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_ALARM_PERIOD_ASSIGN_FAILURE:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_ALARM_PERIOD_CREATE_EVENT:
            return {
                ...state,
                isSubmittingCurrentEvent: true
            };
        case EVENT_ALARM_PERIOD_CREATE_EVENT_SUCCESS:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_ALARM_PERIOD_CREATE_EVENT_FAILURE:
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        case EVENT_CREATE: {
            const { timestamp } = action.payload;
            return {
                ...state,
                timestamp
            };
        }
        case EVENT_UPDATE_REFRESH_TIMESTAMP: {
            const { timestamp } = action.payload;
            return {
                ...state,
                timestamp
            };
        }
        case EVENT_VERSION_CONFLICT_RETRIEVE_SUCCESS: {
            return {
                ...state,
                showConflictedEvent: true,
                conflictedEvent: action.payload
            };
        }
        case EVENT_VERSION_CONFLICT_RESOLVED: {
            return {
                ...state,
                showConflictedEvent: false,
                isSubmittingCurrentEvent: false
            };
        }
        case EVENT_VERSION_CONFLICT_CANCEL: {
            return {
                ...state,
                showConflictedEvent: false,
                isSubmittingCurrentEvent: false
            };
        }
        case EVENT_VERSION_CONFLICT_RETRIEVE_FAILURE: {
            return {
                ...state,
                isSubmittingCurrentEvent: false
            };
        }
        case EVENT_SET_CURRENT_FILTERS: {
            return {
                ...state,
                currentFilters: { ...state.currentFilters, ...action.payload }
            };
        }
        default:
            return state;
    }
};
export default eventsReducer;
